(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/payfooter.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/payfooter.js');

'use strict';

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const ReactPayfooter = svs.tur.ReactPayfooter;
const Payfooter = _ref => {
  let onPay = _ref.onPay;
  const _useSelector = useSelector(state => state.account),
    activeBalance = _useSelector.activeBalance,
    isSyndicate = _useSelector.isSyndicate;
  const sizes = useSelector(state => state.gamePackage.sizes);
  const activeIndex = useSelector(state => state.gamePackage.activeIndex);
  const packageIsClosed = useSelector(state => state.gamePackage.packageIsClosed);
  const packageLabel = useSelector(state => state.gamePackage.title);
  return React.createElement("div", {
    className: "gp-payfooter"
  }, React.createElement(ReactPayfooter.Payfooter, {
    isFixed: isSelfService,
    isBottom: false,
    sum: sizes[activeIndex].price,
    isShowingSum: !isSelfService,
    balance: activeBalance,
    balanceLabel: isSyndicate ? 'Vårt saldo' : 'Mitt saldo',
    buttons: [{
      pay: true,
      onClick: onPay,
      disabled: packageIsClosed
    }],
    reminderTrackingLabel: packageLabel
  }));
};
svs.gamePackage.components.Payfooter = Payfooter;

 })(window);